import React, {useCallback, useEffect, useState} from "react";
import {get} from "../core/http";
import {API} from "../core/constants";
import EntityForm from "./EntityForm";
import {ENTITY_TYPES} from "../core/entity-types";
import PageHeader from "./ui/PageHeader";
import Badge from "./ui/Badge";

const typeLabel = (value) => ENTITY_TYPES.find((t) => t.value === value)?.label || value;

const Entities = () => {
    const [entities, setEntities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState();

    const getEntities = useCallback(async () => {
        try {
            const result = await get(`${API}/entities`);

            if (result.body) {
                setEntities(result.body);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        getEntities();
    }, [getEntities]);

    const addNewEntity = () => {
        setSelectedEntity(null);
        setVisible(true);
    };

    const editEntity = (entity) => {
        setSelectedEntity(entity);
        setVisible(true);
    };

    const handleFormSubmit = async () => {
        await getEntities();
        setSelectedEntity(null);
        setVisible(false);
    };

    return (
        <>
            <PageHeader
                title="Entities"
                count={!loading ? entities.length : null}
                actions={
                    <button className="btn btn-primary btn-sm" onClick={addNewEntity}>
                        Add new
                    </button>
                }
            />

            {loading && !entities.length ? (
                <p className="text-center text-sm text-base-content/60 py-10">Loading...</p>
            ) : !entities.length ? (
                <p className="text-center text-sm text-base-content/60 py-10">No entities yet</p>
            ) : (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
                    {
                        entities.map(entity => (
                            <button
                                key={entity.id}
                                type="button"
                                onClick={() => editEntity(entity)}
                                className="text-left bg-base-100 border border-base-300 rounded-lg p-2 hover:border-primary transition-colors"
                            >
                                {entity.thumbnail ? (
                                    <img className="rounded object-cover w-full h-20 mb-1.5" src={entity.thumbnail} alt="" />
                                ) : (
                                    <div className="rounded bg-base-300 w-full h-20 mb-1.5" />
                                )}
                                <h2 className="text-sm font-medium leading-tight truncate">{entity.name}</h2>
                                <div className="flex items-center justify-between mt-1">
                                    <span className="text-xs text-base-content/50">{typeLabel(entity.type)}</span>
                                    {entity.status === 'draft' && <Badge tone="warning">Draft</Badge>}
                                </div>
                            </button>
                        ))
                    }
                </div>
            )}

            {visible && (
                <EntityForm entity={selectedEntity} onFormSubmit={handleFormSubmit} onCancel={() => setVisible(false)} />
            )}
        </>
    )
}

export default Entities;
